<template>
<!-- FINAL MEMBER -->
  <div class="wrapper">
    <div>
    <div class="card">
      <div class="card-body">
        <CButton color="info" @click="openModalMember"><b>Add Members</b></CButton>
        <CButton class="ml-3"  color="info" @click="openModalNewcomer" ><b>Add Newcomer</b></CButton>
        <CButton class="ml-3"  color="info" @click="openShowUsers" ><b>Show Users</b></CButton>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <CRow>
          <CCol>
             <label class="col-4"> Filter Status </label>
             <CRow>              
              <CCol sm="4" >
              <b-form-select v-model="status" :options="options_status"></b-form-select>
              </CCol>
              <CCol sm="4" >
               <CButton class="col-5" variant="outline" color="info" @click="filter()">Search</CButton>
              </CCol>
            </CRow>
          </CCol>
        </CRow>
      </div>
    </div>
 
    <CRow class="mt-3">
      <div>
      </div>
        <CCol sm="12">
          <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <Datatable 
                            :items="items" 
                            :fields="fields" 
                            :meta="meta" 
                            :is_uuid="true"
                            @per_page="handlePerPage" 
                            @pagination="handlePagination" 
                            @sort="handleSort"
                            @is_active="handleIsActive"
                            @search="handleSearch"
                            :btn_show="true"
                            :btn_edit="false"
                            :btn_deactivate="false"
                            :btn_reactivate="false"
                            :btn_delete="false"
                            :btn_destroy="true"
                            @show="handleShow"
                            @showPeople="handleShowPeople"
                            @editPeople="handleEditPeople"
                            @showMember="handleShowMember"
                            @showNewcomer="handleShowNewcomer"
                            @showVisitor="handleShowVisitor"
                            @convertToMember="handleConvertToMember"
                            @convertToVisitor="handleConvertToVisitor"
                            @setPortalAccess="handleSetPortalAccess"
                            @resetPasswordPeople="handleResetPasswordPeople"
                            @edit="handleEdit"
                            @deactivate="handleDeactivate"
                            @reactivate="handleReactivate"
                        
                           />
                    </div>
                </div>
            </div>
        </div>
      </CCol>
    </CRow>
    <newcomermodal></newcomermodal>
    <visitormodal></visitormodal>
    <membermodal></membermodal>
    <peopledetailmodal></peopledetailmodal>
    <peoplemodal></peoplemodal>
    <alertmodal></alertmodal>

  </div>
  </div>  
</template>

<script>
import Datatable from '@/components/datatables_people.vue' 
import axios from 'axios';
import EventBus from '@/eventBus';

import people from '@/services/people';
import member from '@/services/member';
import membermodal from '@/views/member/member_modal';
import visitor from '@/services/visitor'
import newcomer from '@/services/newcomer';
import newcomermodal from '@/views/newcomer/newcomer_modal.vue';
import visitormodal from '@/views/visitor/detail_modal.vue';
import peopledetailmodal from './people_detail_modal.vue';

import peoplemodal from './people_edit_modal.vue';

import alertmodal from '@/views/alert/modal.vue';
import Multiselect from 'vue-multiselect'

import store from '@/store.js'

const token = localStorage.getItem('token');

export default {
  name: 'MemberTables',
  components: { Datatable, alertmodal,Multiselect, newcomermodal,membermodal,peopledetailmodal, peoplemodal,visitormodal},
  data () {
    return {
      form:{
        firstname:'',
        lastname:'',
        email:'',
        dob:''
      },
      
      updateSubmit: false,
      fields: [
          {key: 'name', sortable: false, label: "Fullname"},
          {key: 'email', sortable: false},
          {key: 'dob', sortable: false},
          {key: 'is_active', sortable: false},
          {key: 'status', sortable: false},
          {key: 'portal_access', sortable: false},
          {key: 'action', sortable: false},
        //   {key: 'notes', sortable: false, label: 'aa'},
        //   {key: 'tithing', sortable: false, thStyle: { backgroundColor: '#3eef33'}},
        //   {key: 'member_attendance', sortable: false},
        //   {key: 'visitor_attendance', sortable: false},
        //   {key: 'created_at', sortable: false},
          // {key: 'covenant_date', sortable: false},
          // {key: 'volunteer_date', sortable: false},
      ],
      items: [],
      options_member:[],
      options_service:[],
      options_keperluan: [],
      options_status: [
        {text: '', value:''},
        {text: 'member', value:'member'},
        {text: 'newcomer', value:'newcomer'},
        {text: 'visitor', value:'visitor'},
      ],
      meta: [],
      current_page: 1,
      per_page: 10,
      search: '',
      sortBy: 'name',
      sortByDesc: false,
      is_active: 1,
      options_icare: [],
      options_month: [
        {text: "January", value: "1"},
        {text: "February", value: "2"},
        {text: "March", value: "3"},
        {text: "April", value: "4"},
        {text: "May", value: "5"},
        {text: "June", value: "6"},
        {text: "July", value: "7"},
        {text: "August", value: "8"},
        {text: "September", value: "9"},
        {text: "October", value: "10"},
        {text: "November", value: "11"},
        {text: "December", value: "12"},
      
      ],
      options_year: [],

      getIcare: [],
      getMonth: [],
      getYear: [],

      icare: '',
      month: '',
      year: ''
    }
   },
    created() {
  },

   mounted (){
     this.loadData()

      EventBus.$on('TABLE_UPDATE', (data) => {
      if(data){
          this.loadData();
      }
    });
   },

  methods: {
     loadData() {


      let current_page = this.search == '' ? this.current_page:1
      var params = {
        headers: { "Authorization" : `Bearer ${token}` },
        page: this.current_page,
        per_page: this.per_page,
        search: this.search,
        sortby: this.sortBy,
        sortbydesc: this.sortByDesc ? 'DESC':'ASC',
        is_active: this.is_active,
        icare: this.icare,
        month: this.month,
        year: this.year,
        status: this.status
      }
      people.getPeopleDatasource(params)
      .then(res => {

          let getData = res.data


          this.items = getData.data
          //this.is_active = res.is_active
          this.meta = {
              total: getData.total,
              current_page: getData.current_page,
              per_page: getData.per_page,
              from: getData.from,
              to: getData.to,
              is_active: res.is_active
          }
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },

     openModalMember: function () {
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Create/edit section') !== -1){
          //IF ALLOW
      var params = {title: 'Add New Member', mode:'create'}
      EventBus.$emit('OPEN_MODAL_MEMBER', params)
      //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
          console.log(' open modal edit')
        } 
      }
      //SET END
    },

    openModalNewcomer: function () {
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Create/edit section') !== -1){
          //IF ALLOW
      var params = {title: 'Add New Newcomer', mode:'create'}
      EventBus.$emit('OPEN_MODAL_NEWCOMER', params)
      //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
          console.log(' open modal edit')
        } 
      }
      //SET END
    },

    openShow(uuid){

    },
    openShowPeople(uuid){

        var params = {title: 'Detail Personal Information', mode:'detail', data:uuid}
        EventBus.$emit('OPEN_SHOW_PEOPLE', params)


    },
    openEditPeople(uuid){
        let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Create/edit new comer') !== -1){
          //IF ALLOW
        var params = {title: 'Edit Personal Information', mode:'edit', data:uuid}
        EventBus.$emit('OPEN_MODAL_EDIT_PEOPLE', params)
        //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
          console.log(' open modal edit')
        } 
      }
      //SET END
    },
    openShowMember(uuid){
        member.getMemberbyID(uuid)
        .then(res => {
        var params = {title: 'Detail member', mode:'detail', data:res.data}
        EventBus.$emit('OPEN_DETAIL_MEMBER', params)
        console.log('OPEN_DETAIL_MEMBER')
        })   
        this.$router.push({name:'Member Detail',query: {Pud:uuid} }) 
    },
    openShowNewcomer(uuid){
       let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Create/edit new comer') !== -1){
          //IF ALLOW
        var params = {title: 'Edit Newcomer', mode:'edit', data:uuid}
        EventBus.$emit('OPEN_MODAL_NEWCOMER', params)
        //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
          console.log(' open modal edit')
        } 
      }
      //SET END
    },
    openShowVisitor(uuid){
        var params = {title: 'Show Visitor', mode:'edit', data:uuid}
        EventBus.$emit('OPEN_MODAL_VISITOR', params)
    },
    convertToMember(uuid){
       //SET PERMISSION EACH FEATURE
    //   let Permission = store.state.user.authenticated.permission
    //   if (typeof Permission != 'undefined') {
    //     if(Permission.indexOf('Delete tujuan') !== -1){
          //IF ALLOW
      if(confirm("Do you really want to convert to member?")){
        people.convertToMember(uuid)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE', true)
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }  
      //END ALLOW
        // }else{
        //   //IF NOT
        //   var params = {title: 'Error', mode:'danger', data:'unautenticated'}
        //   EventBus.$emit('OPEN_MODAL_ALERT', params)
        // } 
      //}
      //SET END
    },
    convertToVisitor(uuid){
       //SET PERMISSION EACH FEATURE
    //   let Permission = store.state.user.authenticated.permission
    //   if (typeof Permission != 'undefined') {
    //     if(Permission.indexOf('Delete tujuan') !== -1){
          //IF ALLOW
      if(confirm("Do you really want to duplicate to visitor?")){
        people.convertToVisitor(uuid)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE', true)
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }  
      //END ALLOW
        // }else{
        //   //IF NOT
        //   var params = {title: 'Error', mode:'danger', data:'unautenticated'}
        //   EventBus.$emit('OPEN_MODAL_ALERT', params)
        // } 
      //}
      //SET END
    },
    setPortalAccess(uuid){
       //SET PERMISSION EACH FEATURE
    //   let Permission = store.state.user.authenticated.permission
    //   if (typeof Permission != 'undefined') {
    //     if(Permission.indexOf('Delete tujuan') !== -1){
          //IF ALLOW
      if(confirm("Do you really want to set portal access?")){
        people.setPortalAccess(uuid)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE', true)
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }  
      //END ALLOW
        // }else{
        //   //IF NOT
        //   var params = {title: 'Error', mode:'danger', data:'unautenticated'}
        //   EventBus.$emit('OPEN_MODAL_ALERT', params)
        // } 
      //}
      //SET END
    },
    resetPasswordPeople(uuid){
       //SET PERMISSION EACH FEATURE
    //   let Permission = store.state.user.authenticated.permission
    //   if (typeof Permission != 'undefined') {
    //     if(Permission.indexOf('Delete tujuan') !== -1){
          //IF ALLOW
      if(confirm("Do you really want to reset password?")){
        people.resetPasswordPeople(uuid)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE', true)
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }  
      //END ALLOW
        // }else{
        //   //IF NOT
        //   var params = {title: 'Error', mode:'danger', data:'unautenticated'}
        //   EventBus.$emit('OPEN_MODAL_ALERT', params)
        // } 
      //}
      //SET END
    },
    deactivate(id){
       //SET PERMISSION EACH FEATURE
      // let Permission = store.state.user.authenticated.permission
      // if (typeof Permission != 'undefined') {
      //   if(Permission.indexOf('Delete tujuan') !== -1){
          //IF ALLOW
      if(confirm("Do you really want to deactivate?")){
        people.deactivatePeople(id)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE', true)
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }  
      //END ALLOW
      //   }else{
      //     //IF NOT
      //     var params = {title: 'Error', mode:'danger', data:'unautenticated'}
      //     EventBus.$emit('OPEN_MODAL_ALERT', params)
      //   } 
      // }
      //SET END
    },

    reactivate(id){
      //SET PERMISSION EACH FEATURE
      // let Permission = store.state.user.authenticated.permission
      // if (typeof Permission != 'undefined') {
      //   if(Permission.indexOf('Delete tujuan') !== -1){
          //IF ALLOW
      if(confirm("Do you really want to reactivate?")){
        people.reactivatePeople(id)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE', true)
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }
      //END ALLOW
      //   }else{
      //     //IF NOT
      //     var params = {title: 'Error', mode:'danger', data:'unautenticated'}
      //     EventBus.$emit('OPEN_MODAL_ALERT', params)
      //   } 
      // }
      //SET END
    },

    openShowUsers(){  
        this.$router.push({name:'Users List Register'}) 
    },

    filter(){
      this.loadData()
    },

    handlePerPage(val) {
        this.per_page = val 
        this.loadData() 
    },
    
    handlePagination(val) {
        this.current_page = val 
        this.loadData()
    },
    
    handleSearch(val) {
        this.search = val 
        this.current_page = 1 
        this.loadData() 
    },
  
    handleSort(val) {
        this.sortBy = val.sortBy
        this.sortByDesc = val.sortDesc
        this.loadData()
    },
    
    handleIsActive(val) {
        this.is_active = val 
        this.loadData() 
    },

////HANDLE FUNCTION BUTTON ACTION////
    handleShow(val) {
        this.openShow(val) 
    }, 
    handleShowPeople(val) {
        this.openShowPeople(val) 
    }, 
    handleEditPeople(val) {
        this.openEditPeople(val) 
    }, 
    handleShowMember(val) {
        this.openShowMember(val) 
    }, 
    handleShowNewcomer(val) {
        this.openShowNewcomer(val) 
    }, 
    handleShowVisitor(val) {
        this.openShowVisitor(val) 
    },  
    handleConvertToMember(val) {
        this.convertToMember(val) 
    },    
    handleConvertToVisitor(val) {
        this.convertToVisitor(val) 
    }, 
    handleSetPortalAccess(val) {
        this.setPortalAccess(val) 
    },   
    handleResetPasswordPeople(val) {
        this.resetPasswordPeople(val) 
    }, 
    handleEdit(val) {
        this.openModalEdit(val) 
    },    
    handleDeactivate(val) {
        this.deactivate(val)       
    },
    handleReactivate(val) {
        this.reactivate(val)       
    },   

  }
  
}
</script>

<style>

</style>
